export default __webpack_public_path__ + "static/media/smallLeftArrow.fd15ff5f.svg";